/**
 * Labstep
 */

export const placeholder = 'Select signature status';
